<template>
    <div>
        <p>
            This search function will find contacts by full or partial
            match on first name, last name, email, or phone.
        </p>
    </div>
</template>
